import type React from "react"
import { Outlet } from "react-router-dom"
import Header from "../components/Header"
import Footer from "../components/Footer"
import { ModalProvider } from "../components/modals/modalProvider"
import MobileBottomNavigation from "../components/navbar/Navbar"
import { createTheme, ThemeProvider } from "@mui/material/styles"

interface MainLayoutProps {
  showFilters?: boolean; 
}

const MainLayout: React.FC<MainLayoutProps> = ({ showFilters = true }) => {
  const theme = createTheme({
  palette: {
    primary: { main: "#28a745" },
    secondary: { main: "#1976D2" }, 
    background: { default: "rgba(207, 255, 245, 0.98)" }, 
  },
});


  return (
    <ThemeProvider theme={theme}>
      <ModalProvider>
        <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
          <Header showFilterOptions={showFilters} /> 
          <main style={{ flex: 1}}>
            <Outlet />
          </main>
          <Footer />
          <MobileBottomNavigation />
        </div>
      </ModalProvider>
    </ThemeProvider>
  )
}

export default MainLayout
